import { defineMessages } from 'react-intl';

export default defineMessages({
    step1: {
        id: 'Checkout.CheckoutProgressBar.step1',
        defaultMessage: '1. Shipping'
    },
    step2: {
        id: 'Checkout.CheckoutProgressBar.step2',
        defaultMessage: '2. Delivery'
    },
    step3: {
        id: 'Checkout.CheckoutProgressBar.step3',
        defaultMessage: '3. Payment'
    },
});